import React from 'react';
import { Create, SimpleForm, TextInput, NumberInput, BooleanInput, required } from 'react-admin';
import { Box, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

export const ServiceBlueprintCreate = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box
          component="button"
          onClick={() => navigate('/crm/service-blueprints')}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            border: '1px solid #ddd',
            borderRadius: 1,
            px: 2,
            py: 1,
            bgcolor: 'background.paper',
            cursor: 'pointer',
            '&:hover': {
              bgcolor: 'grey.100',
            },
            transition: 'all 0.2s ease',
          }}
        >
          <ArrowBackIcon fontSize="small" />
          <Typography variant="body2">Back to Service Blueprints</Typography>
        </Box>
      </Box>

      <Create redirect="list">
        <SimpleForm>
          <TextInput source="name" label="Name" validate={required()} fullWidth />
          <TextInput source="description" label="Description" multiline rows={3} fullWidth />
          <NumberInput source="basePrice" label="Base Price" />
          <NumberInput source="estimatedDuration" label="Duration (minutes)" />
          <BooleanInput source="active" label="Active" defaultValue={true} />
          <BooleanInput source="taxable" label="Taxable" defaultValue={true} />
        </SimpleForm>
      </Create>
    </Box>
  );
};
